













































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import { IPosition, IDepartment } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'position';
const ns = { namespace };

@Component
export default class PositionDetail extends BaseDetail<IPosition> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IPosition>;
  @State('entities', { namespace: 'department' }) departments: Record<
    string,
    IDepartment
  >;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity()?.then(() => {
      this.setValue(this.entityPatch, 'id', Number(this.entityId));
    });
  }
}
